import { styled } from "styled-components";

export const Label = styled.label`
  margin-bottom: 12px;
`;
